const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.MESSAGE)

export const apiClientMessages = {
	fetchClientMessages: async (clientUUID: string): Promise<IClientMessageModel[]> => {
		const { data } = await apiCommon<IClientMessage[]>(`${groupPrefix}/${clientUUID}`, {
			method: 'GET',
		})

		return data.map(d => ClientMessage(d))
	},

	fetchClientParticularMessage: async (messageUUID: string): Promise<IClientMessageModel> => {
		const { data } = await apiCommon<IClientMessage>(`${groupPrefix}/message/${messageUUID}`, {
			method: 'GET',
		})

		return ClientMessage(data)
	},

	createClientMessage: async (payload: IClientMessageCreateModel): Promise<IClientMessageModel> => {
		const body = ClientMessageManageToJson(payload)

		const { data } = await apiCommon<IClientMessage>(`${groupPrefix}/${body.client_uuid}`, {
			method: 'POST',
			body,
		})

		return ClientMessage(data)
	},
}
